<template>
  <div>
    <my-notification :icon="'thumbs-o-up'">
      <template #title>
        {{ $t('compScenarioDocsThanks.title') }}
      </template>
      <div>
        <span v-html="$t('compScenarioDocsThanks.text-1')" />
        <ul class="bcthanks">
          <li>Marion Alliet : Université de Toulouse, Toulouse</li>
          <li>Hanna Bacave : INRAE, Toulouse</li>
          <li>Tamara Ben Ari : CIRED, Nogent sur Marne</li>
          <li>Vincent Gerbaud : CNRS, Toulouse</li>
          <li>Daniel Lacour : CNRS / Université de Laurraine, Nancy</li>
          <li>Mathieu Lambotte : Université Grenoble Alpes, Grenoble</li>
          <li>Gaëlle Lefort : INRAE, Nouzilly</li>
          <li>Romain Lorrilliere : MNHN, Paris</li>
          <li>Nicolas Mauran : CNRS, Toulouse</li>
          <li>Dominique Nguyen: Science Po, Bordeaux</li>
          <li>Laurent Perrin : INSERM, Marseille</li>
          <li>Catherine Picon-Cochard : INRAE, Clermont Ferrand</li>
          <li>
            Alexandre Santerne : CNRS / Aix-Marseille Université, Marseille
          </li>
        </ul>
      </div>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Thanks',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcthanks {
  list-style-type: square;
  margin-left: 25px;
}
.bcthanks > li {
  padding-top: 5px;
}
</style>
